export default "__VITE_ASSET__ZrAe3hMn__"